















































import { Vue, Component } from 'vue-property-decorator';
import { GetOrdersByOrderNoFreeGiftsResponse } from 'ncp-api-supporter/dist/types';
import { OrderFreeGiftFailReasonType } from 'ncp-api-supporter/dist/types/enum';
import { FREE_GIFT_FAIL_REASON } from '@/const/words/orderLayer';
import { convertProductUri } from '@/utils/commonUtils';
@Component
export default class FreeGifts extends Vue {
  private freeGift = {} as GetOrdersByOrderNoFreeGiftsResponse;
  
  private openTargetProductDetailPage() {
    const productUrl = `${this.$route.query.productUrl}`;
    const uri = convertProductUri(productUrl, `${this.freeGift.targetProductNo}`);
    window.open(uri);
  }
  
  private parseFreeGift() {
    this.freeGift = JSON.parse(`${this.$route.query.data}`);
  }
  
  private getFailReasonLabel(type?: OrderFreeGiftFailReasonType): string {
    return FREE_GIFT_FAIL_REASON[type] ?? '';
  }
  
  private created() {
    this.parseFreeGift();
  }
}
